import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Task } from '../../services/task.service';

@Component({
    selector: 'app-task-summary-tile',
    templateUrl: './task-summary-tile.component.html',
    styleUrls: ['./task-summary-tile.component.sass'],
    standalone: false
})
export class TaskSummaryTileComponent {
  @Input() task!: Task;
  @Output() taskClick = new EventEmitter<number>();

  getPriorityColor(priority: string): string {
    switch (priority) {
      case 'HIGH':
        return 'red';
      case 'NORMAL':
        return 'gold';
      case 'LOW':
        return 'green';
      default:
        return 'gray';
    }
  }

  onTaskClick(): void {
    this.taskClick.emit(this.task.id);
  }
}
